import React, { Component } from 'react'
import AssemblyPartEditForm from './part.component.jsx'
import {FormattedMessage} from 'react-intl'
const uuidv4 = require('uuid/v4')

class AssemblyPartsForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            modal: '',
            parts: this.props.value || [],
            formulas: this.props.formulas || [],
            terms: this.props.terms || [],
            hasCalculator: this.props.hasCalculator || false,
        }
        const defaultCallback = () => {}
        this.onChange = this.props.onChange || defaultCallback
        this.newPart = this.newPart.bind(this)
        this.deletePart = this.deletePart.bind(this)
        this.newChoice = this.newChoice.bind(this)
        this.updatePart = this.updatePart.bind(this)
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {
        this.setState({
            terms: nextProps.terms || [],
            hasCalculator: nextProps.hasCalculator || false,
        })
    }

    newPart(event) {
        const parts = this.state.parts
        const partId = uuidv4()
        parts.push({
            id: partId,
            type: 'single',
            name: '',
            required: false,
            sequence: parts.length.toString(),
            choices: [],
        })
        const formulas = this.state.formulas
        formulas.push({
            formula: '',
            partId: partId,
            calculatorFormulaId: uuidv4(),
        })
        this.setState({
            parts: parts,
            formulas: formulas,
        }, () => {
            this.onChange(this.state.parts, this.state.formulas)
        })
        event.preventDefault()
    }

    deletePart(part) {
        this.setState({
            parts: this.state.parts.filter(p => p.id !== part.id),
            formulas: this.state.formulas.filter(f => f.partId !== part.id)
        }, () => {
            this.onChange(this.state.parts, this.state.formulas)
        })
    }

    updatePart(part, formula) {
        let formulas = this.state.formulas
        if (formulas.filter(f => f.partId === part.id).length > 0) {
            formulas = formulas.map(f => {
                if (f.partId === part.id) {
                    return formula
                } else {
                    return f
                }
            })
        } else {
            if (formula) {
                formula.calculatorFormulaId = uuidv4()
                formula.partId = part.id
                formulas.push(formula)
            }
        }

        this.setState({
            parts: this.state.parts.map(p => {
                if (p.id === part.id) {
                    return part
                } else {
                    return p
                }
            }),
            formulas: formulas
        }, () => {
            this.onChange(this.state.parts, this.state.formulas)
        })
    }

    newChoice(part) {
        this.setState({
            parts: this.state.parts.map(p => {
                if (p.id === part.id) {
                    p.choices.push({
                        id: uuidv4(),
                        productId: '',
                        additionalUnitPrice: '',
                        sequence: p.choices.length.toString(),
                    })
                }
                return p
            })
        }, () => {
            this.onChange(this.state.parts)
        })
        event.preventDefault()
    }

    getFormulaByPartId(partId) {
        return this.state.formulas.filter(f => f.partId === partId)[0]
    }

    render() {
        const parts = this.state.parts.map(p => {
            return <AssemblyPartEditForm
                part={p}
                formula={this.getFormulaByPartId(p.id)}
                terms={this.state.terms}
                hasCalculator={this.state.hasCalculator}
                key={p.id}
                onDelete={this.deletePart}
                onNewChoice={this.newChoice}
                onChange={this.updatePart}
            />
        })

        return (
            <div>
                {parts}
                <div className="row">
                    <div className="col-12">
                        <button className="btn btn-sm btn-primary" onClick={this.newPart}>
                            <FormattedMessage
                                id="product.assembly.form.add_part_btn"
                                defaultMessage="Add Part"
                            />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default AssemblyPartsForm


// WEBPACK FOOTER //
// ./src/product/form/assembly/form.component.jsx